import { render, staticRenderFns } from "./CreateCarrier.vue?vue&type=template&id=0ea65d86&lang=pug&"
import script from "./CreateCarrier.vue?vue&type=script&lang=js&"
export * from "./CreateCarrier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports